import type { SubscriptionOverviewResponse } from "@nlc/shared-types";

import { LayersIcon } from "lucide-react";

import { Badge } from "@/components/badge";

// The subscription backend does not expose support tier or design-slot capacity
// yet, so both fall back to the values shown in the Figma frame. Drop the
// fallbacks once the endpoint fills plan.supportTier and plan.designSlotCount.
const MOCK_SUPPORT_TIER = "fully-managed";
const MOCK_DESIGN_SLOT_COUNT = 5;
const MOCK_ADDONS = [{ name: "Concierge connect" }, { name: "Web Hosting" }];

const SUPPORT_TIER_LABEL = {
  "fully-managed": "Fully-managed",
  "self-managed": "Self-managed",
} as const;

export function CurrentPlanCard({
  data,
}: {
  data: Pick<SubscriptionOverviewResponse, "addOns" | "plan">;
}) {
  const { addOns, plan } = data;

  const supportTier = plan.supportTier ?? MOCK_SUPPORT_TIER;
  const designSlotCount = plan.designSlotCount ?? MOCK_DESIGN_SLOT_COUNT;
  const addons = addOns ?? MOCK_ADDONS;

  return (
    <div className="inline-flex flex-col justify-between gap-md rounded-xl border border-border-secondary bg-bg-primary py-xl px-3xl">
      <div className="flex items-start justify-between gap-xl">
        <div className="flex flex-col gap-xs">
          <h3 className="text-xs font-medium text-text-tertiary">
            Current plan
          </h3>
          <p className="text-xl font-semibold text-text-primary">
            {plan.productName}
          </p>
        </div>
        <div className="h-10 w-10 rounded-md bg-bg-brand-secondary flex items-center justify-center">
          <LayersIcon className="text-text-brand-primary" size={20} />
        </div>
      </div>

      <div className="flex flex-wrap gap-md">
        <Badge size="small">{SUPPORT_TIER_LABEL[supportTier]}</Badge>
        <Badge size="small">{designSlotCount} design slots</Badge>
        {addons.map((addon) => (
          <Badge key={addon.name} size="small">
            {addon.name}
          </Badge>
        ))}
      </div>
    </div>
  );
}
